module.exports = __webpack_public_path__ + "img/my.my1f599a0.svg";